
import * as Sentry from "@sentry/react";

export const captureException = e => {
  if (process.env.REACT_APP_ENV === 'production') {
    Sentry.captureException(e);
  }
}